import React, { Component } from 'react';
import Accordion from '@material-ui/core/Accordion';
import AccordionSummary from '@material-ui/core/AccordionSummary';
import AccordionDetails from '@material-ui/core/AccordionDetails';
import { Typography, withStyles } from '@material-ui/core';
import ExpandMoreIcon from '@material-ui/icons/ExpandMore';

import { BBS_API_URL, EVENT_ID } from '../constants';

const styles = (theme) => ({
  accordionDiv: {
    borderBottom: '1px solid rgba(0,0,0,0.3)',
    marginBottom: '2em',
    [theme.breakpoints.down('sm')]: {},
  },
  qnaAccordion: {
    boxShadow: 'none',
    borderBottom: '1px solid rgba(0,0,0,0.2)',
  },
  summaryAccordion: {
    '&:hover': {
      '& *': { color: theme.palette.secondary.main },
    },
  },
  qContent: {
    fontSize: '16px',
    fontWeight: 'bold',
  },
  qMark: {
    color: theme.palette.primary.main,
    marginRight: '0.5em',
  },
  aContent: {
    backgroundColor: 'rgba(239, 239, 239, 0.15)',
    borderTop: '1px solid rgba(0,0,0,0.2)',
    padding: '20px 45px',
    [theme.breakpoints.down('sm')]: {
      padding: '15px 25px',
    },
    '& table': {
      width: '100% !important',
      borderCollapse: 'collapse',
    },
    '& td': {
      border: '1px solid dimgray',
      padding: '4px',
      background: 'white',
    },
    '& tr': {
      '&:first-child': {
        '& td': {
          backgroundColor: `${theme.palette.primary.bg} !important`,
          fontWeight: 'bold',
        },
      },
    },
  },
});

class FAQAccordion extends Component {
  constructor(props) {
    super(props);
    this.state = {
      faqList: [],
      expaneded: '',
    };
    this.handleChange = this.handleChange.bind(this);
  }

  componentDidMount() {
    fetch(`${BBS_API_URL}/faq/list?eventId=${EVENT_ID}`, {
      method: 'GET',
    })
      .then((res) => res.text())
      .then((body) => {
        let _result = JSON.parse(body);
        _result.Items.sort((a, b) => {
          return Number(a.sortOrder) > Number(b.sortOrder) ? 1 : -1;
        });
        // console.log(_result);
        this.setState({ faqList: _result.Items });
      })
      .catch((err) => {
        console.log(err);
      });
  }

  handleChange = (panel) => (event, newExpanded) => {
    this.setState({ expaneded: newExpanded ? panel : '' });
  };

  render() {
    const { classes } = this.props;

    const faqList = (datas) => {
      return datas.map((faq, i) => {
        return (
          <Accordion
            square
            expanded={this.state.expaneded === faq.id ? true : false}
            key={i}
            className={classes.qnaAccordion}
            style={{ margin: 0 }}
            onChange={this.handleChange(faq.id)}
          >
            <AccordionSummary
              expandIcon={
                this.state.expaneded === faq.id ? (
                  <ExpandMoreIcon style={{ color: '#545c80' }} />
                ) : (
                  <ExpandMoreIcon style={{ color: '#adadad' }} />
                )
              }
              key={i}
              className={classes.summaryAccordion}
            >
              <Typography className={classes.qContent}>
                <span className={classes.qMark}>
                  Q<span style={{ fontSize: 'small' }}>{i + 1}</span>.
                </span>
                {faq.faqTitle}
              </Typography>
            </AccordionSummary>
            <AccordionDetails className={classes.aContent}>
              <div dangerouslySetInnerHTML={{ __html: faq.faqContents }} />
            </AccordionDetails>
          </Accordion>
        );
      });
    };

    return <div className={classes.accordionDiv}>{this.state.faqList ? faqList(this.state.faqList) : ''}</div>;
  }
}

export default withStyles(styles, { withTheme: true })(FAQAccordion);
